export default "__VITE_ASSET__Caq3syoc__"